import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import $682989befd4f478d$exports from "./ar-AE.module.js";
import $f7fca02019afd941$exports from "./bg-BG.module.js";
import $8f86f40be75387f1$exports from "./cs-CZ.module.js";
import $db24ba43c8d652ee$exports from "./da-DK.module.js";
import $f8f1e72c8b5447d6$exports from "./de-DE.module.js";
import $9a73ed2983c3ab0b$exports from "./el-GR.module.js";
import $583de0b3587601b9$exports from "./en-US.module.js";
import $147159c978043442$exports from "./es-ES.module.js";
import $5cbb62c8a19173ac$exports from "./et-EE.module.js";
import $a33d71dc804cc59e$exports from "./fi-FI.module.js";
import $92d800447793d084$exports from "./fr-FR.module.js";
import $fe732cdb32124ea8$exports from "./he-IL.module.js";
import $e41234e934efb4f5$exports from "./hr-HR.module.js";
import $1b0393182473bf9e$exports from "./hu-HU.module.js";
import $2eed782c1c110ce7$exports from "./it-IT.module.js";
import $8b5d459f86e9b23c$exports from "./ja-JP.module.js";
import $1949c3ad17295fd4$exports from "./ko-KR.module.js";
import $f5e3df4dc8aa7b54$exports from "./lt-LT.module.js";
import $9dd86690a5c2b2c5$exports from "./lv-LV.module.js";
import $843964c3bf9a7d24$exports from "./nb-NO.module.js";
import $73f50e845f9ef3b4$exports from "./nl-NL.module.js";
import $87f92a7e077514b2$exports from "./pl-PL.module.js";
import $c28c98d58ee9ff6f$exports from "./pt-BR.module.js";
import $b6b1503b17b2254d$exports from "./pt-PT.module.js";
import $8bdaeb71e50c3e1a$exports from "./ro-RO.module.js";
import $ec2b852dd7c3d1f2$exports from "./ru-RU.module.js";
import $79e6d900d6a4f82d$exports from "./sk-SK.module.js";
import $f4c1f0d5d4d03d80$exports from "./sl-SI.module.js";
import $46252cd87269b10b$exports from "./sr-SP.module.js";
import $d4d5d8dab362555c$exports from "./sv-SE.module.js";
import $3d55d1f97c377e83$exports from "./tr-TR.module.js";
import $5368512f1c703a3f$exports from "./uk-UA.module.js";
import $f1316b1074463583$exports from "./zh-CN.module.js";
import $7e60654723031b6f$exports from "./zh-TW.module.js";
import { getNthItem as $cVkRF$getNthItem, getChildNodes as $cVkRF$getChildNodes, getLastItem as $cVkRF$getLastItem, getFirstItem as $cVkRF$getFirstItem } from "@react-stately/collections";
import { Rect as $cVkRF$Rect } from "@react-stately/virtualizer";
import { useId as $cVkRF$useId, filterDOMProps as $cVkRF$filterDOMProps, mergeProps as $cVkRF$mergeProps, useUpdateEffect as $cVkRF$useUpdateEffect, useDescription as $cVkRF$useDescription, scrollIntoViewport as $cVkRF$scrollIntoViewport, getScrollParent as $cVkRF$getScrollParent } from "@react-aria/utils";
import { useMemo as $cVkRF$useMemo, useCallback as $cVkRF$useCallback, useRef as $cVkRF$useRef } from "react";
import { useCollator as $cVkRF$useCollator, useLocale as $cVkRF$useLocale, useLocalizedStringFormatter as $cVkRF$useLocalizedStringFormatter } from "@react-aria/i18n";
import { useHasTabbableChild as $cVkRF$useHasTabbableChild, getFocusableTreeWalker as $cVkRF$getFocusableTreeWalker, focusSafely as $cVkRF$focusSafely } from "@react-aria/focus";
import { useSelectableCollection as $cVkRF$useSelectableCollection, useSelectableItem as $cVkRF$useSelectableItem } from "@react-aria/selection";
import { announce as $cVkRF$announce } from "@react-aria/live-announcer";
import { useInteractionModality as $cVkRF$useInteractionModality, isFocusVisible as $cVkRF$isFocusVisible } from "@react-aria/interactions";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $d1c300d9c497e402$export$de9feff04fda126e = /*#__PURE__*/function () {
  _createClass($d1c300d9c497e402$export$de9feff04fda126e, [{
    key: "isCell",
    value: function isCell(node) {
      return node.type === "cell";
    }
  }, {
    key: "isRow",
    value: function isRow(node) {
      return node.type === "row" || node.type === "item";
    }
  }, {
    key: "findPreviousKey",
    value: function findPreviousKey(fromKey, pred) {
      var key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
      while (key != null) {
        var item = this.collection.getItem(key);
        if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
        key = this.collection.getKeyBefore(key);
      }
    }
  }, {
    key: "findNextKey",
    value: function findNextKey(fromKey, pred) {
      var key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
      while (key != null) {
        var item = this.collection.getItem(key);
        if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
        key = this.collection.getKeyAfter(key);
      }
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      var startItem = this.collection.getItem(key);
      if (!startItem) return;
      // If focus was on a cell, start searching from the parent row
      if (this.isCell(startItem)) key = startItem.parentKey;
      // Find the next item
      key = this.findNextKey(key);
      if (key != null) {
        // If focus was on a cell, focus the cell with the same index in the next row.
        if (this.isCell(startItem)) {
          var item = this.collection.getItem(key);
          return (0, $cVkRF$getNthItem)((0, $cVkRF$getChildNodes)(item, this.collection), startItem.index).key;
        }
        // Otherwise, focus the next row
        if (this.focusMode === "row") return key;
      }
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      var startItem = this.collection.getItem(key);
      if (!startItem) return;
      // If focus is on a cell, start searching from the parent row
      if (this.isCell(startItem)) key = startItem.parentKey;
      // Find the previous item
      key = this.findPreviousKey(key);
      if (key != null) {
        // If focus was on a cell, focus the cell with the same index in the previous row.
        if (this.isCell(startItem)) {
          var item = this.collection.getItem(key);
          return (0, $cVkRF$getNthItem)((0, $cVkRF$getChildNodes)(item, this.collection), startItem.index).key;
        }
        // Otherwise, focus the previous row
        if (this.focusMode === "row") return key;
      }
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      var item = this.collection.getItem(key);
      if (!item) return;
      // If focus is on a row, focus the first child cell.
      if (this.isRow(item)) {
        var children = (0, $cVkRF$getChildNodes)(item, this.collection);
        return this.direction === "rtl" ? (0, $cVkRF$getLastItem)(children).key : (0, $cVkRF$getFirstItem)(children).key;
      }
      // If focus is on a cell, focus the next cell if any,
      // otherwise focus the parent row.
      if (this.isCell(item)) {
        var parent = this.collection.getItem(item.parentKey);
        var _children = (0, $cVkRF$getChildNodes)(parent, this.collection);
        var next = this.direction === "rtl" ? (0, $cVkRF$getNthItem)(_children, item.index - 1) : (0, $cVkRF$getNthItem)(_children, item.index + 1);
        if (next) return next.key;
        // focus row only if focusMode is set to row
        if (this.focusMode === "row") return item.parentKey;
        return this.direction === "rtl" ? this.getFirstKey(key) : this.getLastKey(key);
      }
    }
  }, {
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      var item = this.collection.getItem(key);
      if (!item) return;
      // If focus is on a row, focus the last child cell.
      if (this.isRow(item)) {
        var children = (0, $cVkRF$getChildNodes)(item, this.collection);
        return this.direction === "rtl" ? (0, $cVkRF$getFirstItem)(children).key : (0, $cVkRF$getLastItem)(children).key;
      }
      // If focus is on a cell, focus the previous cell if any,
      // otherwise focus the parent row.
      if (this.isCell(item)) {
        var parent = this.collection.getItem(item.parentKey);
        var _children2 = (0, $cVkRF$getChildNodes)(parent, this.collection);
        var prev = this.direction === "rtl" ? (0, $cVkRF$getNthItem)(_children2, item.index + 1) : (0, $cVkRF$getNthItem)(_children2, item.index - 1);
        if (prev) return prev.key;
        // focus row only if focusMode is set to row
        if (this.focusMode === "row") return item.parentKey;
        return this.direction === "rtl" ? this.getLastKey(key) : this.getFirstKey(key);
      }
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey(key, global) {
      var item;
      if (key != null) {
        item = this.collection.getItem(key);
        if (!item) return;
        // If global flag is not set, and a cell is currently focused,
        // move focus to the first cell in the parent row.
        if (this.isCell(item) && !global) {
          var parent = this.collection.getItem(item.parentKey);
          return (0, $cVkRF$getFirstItem)((0, $cVkRF$getChildNodes)(parent, this.collection)).key;
        }
      }
      // Find the first row
      key = this.findNextKey();
      // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
      if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
        var _item = this.collection.getItem(key);
        key = (0, $cVkRF$getFirstItem)((0, $cVkRF$getChildNodes)(_item, this.collection)).key;
      }
      // Otherwise, focus the row itself.
      return key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey(key, global) {
      var item;
      if (key != null) {
        item = this.collection.getItem(key);
        if (!item) return;
        // If global flag is not set, and a cell is currently focused,
        // move focus to the last cell in the parent row.
        if (this.isCell(item) && !global) {
          var parent = this.collection.getItem(item.parentKey);
          var children = (0, $cVkRF$getChildNodes)(parent, this.collection);
          return (0, $cVkRF$getLastItem)(children).key;
        }
      }
      // Find the last row
      key = this.findPreviousKey();
      // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
      if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
        var _item2 = this.collection.getItem(key);
        var _children3 = (0, $cVkRF$getChildNodes)(_item2, this.collection);
        key = (0, $cVkRF$getLastItem)(_children3).key;
      }
      // Otherwise, focus the row itself.
      return key;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.ref.current.querySelector("[data-key=\"".concat(CSS.escape(key.toString()), "\"]"));
    }
  }, {
    key: "getItemRect",
    value: function getItemRect(key) {
      var _this_layout_getLayoutInfo;
      if (this.layout) return (_this_layout_getLayoutInfo = this.layout.getLayoutInfo(key)) === null || _this_layout_getLayoutInfo === void 0 ? void 0 : _this_layout_getLayoutInfo.rect;
      var item = this.getItem(key);
      if (item) return new (0, $cVkRF$Rect)(item.offsetLeft, item.offsetTop, item.offsetWidth, item.offsetHeight);
    }
  }, {
    key: "getPageHeight",
    value: function getPageHeight() {
      var _this_layout_virtualizer, _this_ref_current, _this_ref;
      if (this.layout) return (_this_layout_virtualizer = this.layout.virtualizer) === null || _this_layout_virtualizer === void 0 ? void 0 : _this_layout_virtualizer.visibleRect.height;
      return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.offsetHeight;
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight() {
      var _this_ref_current, _this_ref;
      if (this.layout) return this.layout.getContentSize().height;
      return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.scrollHeight;
    }
  }, {
    key: "getKeyPageAbove",
    value: function getKeyPageAbove(key) {
      var itemRect = this.getItemRect(key);
      if (!itemRect) return null;
      var pageY = Math.max(0, itemRect.maxY - this.getPageHeight());
      while (itemRect && itemRect.y > pageY) {
        key = this.getKeyAbove(key);
        itemRect = this.getItemRect(key);
      }
      return key;
    }
  }, {
    key: "getKeyPageBelow",
    value: function getKeyPageBelow(key) {
      var itemRect = this.getItemRect(key);
      if (!itemRect) return null;
      var pageHeight = this.getPageHeight();
      var pageY = Math.min(this.getContentHeight(), itemRect.y + pageHeight);
      while (itemRect && itemRect.maxY < pageY) {
        var nextKey = this.getKeyBelow(key);
        itemRect = this.getItemRect(nextKey);
        // Guard against case where maxY of the last key is barely less than pageY due to rounding
        // and thus it attempts to set key to null
        if (nextKey != null) key = nextKey;
      }
      return key;
    }
  }, {
    key: "getKeyForSearch",
    value: function getKeyForSearch(search, fromKey) {
      if (!this.collator) return null;
      var collection = this.collection;
      var key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
      // If the starting key is a cell, search from its parent row.
      var startItem = collection.getItem(key);
      if (startItem.type === "cell") key = startItem.parentKey;
      var hasWrapped = false;
      while (key != null) {
        var item = collection.getItem(key);
        // check row text value for match
        if (item.textValue) {
          var substring = item.textValue.slice(0, search.length);
          if (this.collator.compare(substring, search) === 0) {
            if (this.isRow(item) && this.focusMode === "cell") return (0, $cVkRF$getFirstItem)((0, $cVkRF$getChildNodes)(item, this.collection)).key;
            return item.key;
          }
        }
        key = this.findNextKey(key);
        // Wrap around when reaching the end of the collection
        if (key == null && !hasWrapped) {
          key = this.getFirstKey();
          hasWrapped = true;
        }
      }
      return null;
    }
  }]);
  function $d1c300d9c497e402$export$de9feff04fda126e(options) {
    _classCallCheck(this, $d1c300d9c497e402$export$de9feff04fda126e);
    this.collection = options.collection;
    this.disabledKeys = options.disabledKeys;
    this.ref = options.ref;
    this.direction = options.direction;
    this.collator = options.collator;
    this.layout = options.layout;
    this.focusMode = options.focusMode || "row";
  }
  return $d1c300d9c497e402$export$de9feff04fda126e;
}();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $1af922eb41e03c8f$export$e6235c0d09b995d0 = new WeakMap();

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $835c96616a7cb4f9$exports = {};
$835c96616a7cb4f9$exports = {
  "ar-AE": $682989befd4f478d$exports,
  "bg-BG": $f7fca02019afd941$exports,
  "cs-CZ": $8f86f40be75387f1$exports,
  "da-DK": $db24ba43c8d652ee$exports,
  "de-DE": $f8f1e72c8b5447d6$exports,
  "el-GR": $9a73ed2983c3ab0b$exports,
  "en-US": $583de0b3587601b9$exports,
  "es-ES": $147159c978043442$exports,
  "et-EE": $5cbb62c8a19173ac$exports,
  "fi-FI": $a33d71dc804cc59e$exports,
  "fr-FR": $92d800447793d084$exports,
  "he-IL": $fe732cdb32124ea8$exports,
  "hr-HR": $e41234e934efb4f5$exports,
  "hu-HU": $1b0393182473bf9e$exports,
  "it-IT": $2eed782c1c110ce7$exports,
  "ja-JP": $8b5d459f86e9b23c$exports,
  "ko-KR": $1949c3ad17295fd4$exports,
  "lt-LT": $f5e3df4dc8aa7b54$exports,
  "lv-LV": $9dd86690a5c2b2c5$exports,
  "nb-NO": $843964c3bf9a7d24$exports,
  "nl-NL": $73f50e845f9ef3b4$exports,
  "pl-PL": $87f92a7e077514b2$exports,
  "pt-BR": $c28c98d58ee9ff6f$exports,
  "pt-PT": $b6b1503b17b2254d$exports,
  "ro-RO": $8bdaeb71e50c3e1a$exports,
  "ru-RU": $ec2b852dd7c3d1f2$exports,
  "sk-SK": $79e6d900d6a4f82d$exports,
  "sl-SI": $f4c1f0d5d4d03d80$exports,
  "sr-SP": $46252cd87269b10b$exports,
  "sv-SE": $d4d5d8dab362555c$exports,
  "tr-TR": $3d55d1f97c377e83$exports,
  "uk-UA": $5368512f1c703a3f$exports,
  "zh-CN": $f1316b1074463583$exports,
  "zh-TW": $7e60654723031b6f$exports
};
function $92599c3fd427b763$export$137e594ef3218a10(props, state) {
  var _props$getRowText = props.getRowText,
    getRowText = _props$getRowText === void 0 ? function (key) {
      var _state_collection_getTextValue, _state_collection, _state_collection_getItem;
      var _state_collection_getTextValue1;
      return (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
    } : _props$getRowText;
  var stringFormatter = (0, $cVkRF$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($835c96616a7cb4f9$exports)), "@react-aria/grid");
  // Many screen readers do not announce when items in a grid are selected/deselected.
  // We do this using an ARIA live region.
  var selection = state.selectionManager.rawSelection;
  var lastSelection = (0, $cVkRF$useRef)(selection);
  (0, $cVkRF$useUpdateEffect)(function () {
    var _lastSelection_current;
    if (!state.selectionManager.isFocused) {
      lastSelection.current = selection;
      return;
    }
    var addedKeys = $92599c3fd427b763$var$diffSelection(selection, lastSelection.current);
    var removedKeys = $92599c3fd427b763$var$diffSelection(lastSelection.current, selection);
    // If adding or removing a single row from the selection, announce the name of that item.
    var isReplace = state.selectionManager.selectionBehavior === "replace";
    var messages = [];
    if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
      if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
        var currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
        if (currentSelectionText) messages.push(stringFormatter.format("selectedItem", {
          item: currentSelectionText
        }));
      }
    } else if (addedKeys.size === 1 && removedKeys.size === 0) {
      var addedText = getRowText(addedKeys.keys().next().value);
      if (addedText) messages.push(stringFormatter.format("selectedItem", {
        item: addedText
      }));
    } else if (removedKeys.size === 1 && addedKeys.size === 0) {
      if (state.collection.getItem(removedKeys.keys().next().value)) {
        var removedText = getRowText(removedKeys.keys().next().value);
        if (removedText) messages.push(stringFormatter.format("deselectedItem", {
          item: removedText
        }));
      }
    }
    // Announce how many items are selected, except when selecting the first item.
    if (state.selectionManager.selectionMode === "multiple") {
      if (messages.length === 0 || selection === "all" || selection.size > 1 || lastSelection.current === "all" || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === "all" ? stringFormatter.format("selectedAll") : stringFormatter.format("selectedCount", {
        count: selection.size
      }));
    }
    if (messages.length > 0) (0, $cVkRF$announce)(messages.join(" "));
    lastSelection.current = selection;
  }, [selection]);
}
function $92599c3fd427b763$var$diffSelection(a, b) {
  var res = new Set();
  if (a === "all" || b === "all") return res;
  var _iterator = _createForOfIteratorHelper(a.keys()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (!b.has(key)) res.add(key);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return res;
}

/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $5b9b5b5723db6ae1$export$be42ebdab07ae4c2(props) {
  var stringFormatter = (0, $cVkRF$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($835c96616a7cb4f9$exports)), "@react-aria/grid");
  var modality = (0, $cVkRF$useInteractionModality)();
  // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
  var shouldLongPress = (modality === "pointer" || modality === "virtual" || modality == null) && typeof window !== "undefined" && "ontouchstart" in window;
  var interactionDescription = (0, $cVkRF$useMemo)(function () {
    var selectionMode = props.selectionManager.selectionMode;
    var selectionBehavior = props.selectionManager.selectionBehavior;
    var message = undefined;
    if (shouldLongPress) message = stringFormatter.format("longPressToSelect");
    return selectionBehavior === "replace" && selectionMode !== "none" && props.hasItemActions ? message : undefined;
  }, [props.selectionManager.selectionMode, props.selectionManager.selectionBehavior, props.hasItemActions, stringFormatter, shouldLongPress]);
  var descriptionProps = (0, $cVkRF$useDescription)(interactionDescription);
  return descriptionProps;
}
function $83c6e2eafa584c67$export$f6b86a04e5d66d90(props, state, ref) {
  var isVirtualized = props.isVirtualized,
    keyboardDelegate = props.keyboardDelegate,
    focusMode = props.focusMode,
    scrollRef = props.scrollRef,
    getRowText = props.getRowText,
    onRowAction = props.onRowAction,
    onCellAction = props.onCellAction;
  var manager = state.selectionManager;
  if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.
  var collator = (0, $cVkRF$useCollator)({
    usage: "search",
    sensitivity: "base"
  });
  var _ref = (0, $cVkRF$useLocale)(),
    direction = _ref.direction;
  var disabledBehavior = state.selectionManager.disabledBehavior;
  var delegate = (0, $cVkRF$useMemo)(function () {
    return keyboardDelegate || new (0, $d1c300d9c497e402$export$de9feff04fda126e)({
      collection: state.collection,
      disabledKeys: disabledBehavior === "selection" ? new Set() : state.disabledKeys,
      ref: ref,
      direction: direction,
      collator: collator,
      focusMode: focusMode
    });
  }, [keyboardDelegate, state.collection, state.disabledKeys, disabledBehavior, ref, direction, collator, focusMode]);
  var _ref2 = (0, $cVkRF$useSelectableCollection)({
      ref: ref,
      selectionManager: manager,
      keyboardDelegate: delegate,
      isVirtualized: isVirtualized,
      scrollRef: scrollRef
    }),
    collectionProps = _ref2.collectionProps;
  var id = (0, $cVkRF$useId)(props.id);
  (0, $1af922eb41e03c8f$export$e6235c0d09b995d0).set(state, {
    keyboardDelegate: delegate,
    actions: {
      onRowAction: onRowAction,
      onCellAction: onCellAction
    }
  });
  var descriptionProps = (0, $5b9b5b5723db6ae1$export$be42ebdab07ae4c2)({
    selectionManager: manager,
    hasItemActions: !!(onRowAction || onCellAction)
  });
  var domProps = (0, $cVkRF$filterDOMProps)(props, {
    labelable: true
  });
  var onFocus = (0, $cVkRF$useCallback)(function (e) {
    if (manager.isFocused) {
      // If a focus event bubbled through a portal, reset focus state.
      if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
      return;
    }
    // Focus events can bubble through portals. Ignore these events.
    if (!e.currentTarget.contains(e.target)) return;
    manager.setFocused(true);
  }, [manager]);
  // Continue to track collection focused state even if keyboard navigation is disabled
  var navDisabledHandlers = (0, $cVkRF$useMemo)(function () {
    return {
      onBlur: collectionProps.onBlur,
      onFocus: onFocus
    };
  }, [onFocus, collectionProps.onBlur]);
  var hasTabbableChild = (0, $cVkRF$useHasTabbableChild)(ref, {
    isDisabled: state.collection.size !== 0
  });
  var gridProps = (0, $cVkRF$mergeProps)(domProps, {
    role: "grid",
    id: id,
    "aria-multiselectable": manager.selectionMode === "multiple" ? "true" : undefined
  }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps,
  // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
  state.collection.size === 0 && {
    tabIndex: hasTabbableChild ? -1 : 0
  }, descriptionProps);
  if (isVirtualized) {
    gridProps["aria-rowcount"] = state.collection.size;
    gridProps["aria-colcount"] = state.collection.columnCount;
  }
  (0, $92599c3fd427b763$export$137e594ef3218a10)({
    getRowText: getRowText
  }, state);
  return {
    gridProps: gridProps
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $e45487f8ba1cbdbf$export$d3037f5d3f3e51bf() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $4159a7a9cbb0cc18$export$96357d5a73f686fa(props, state, ref) {
  var node = props.node,
    isVirtualized = props.isVirtualized,
    shouldSelectOnPressUp = props.shouldSelectOnPressUp,
    onAction = props.onAction;
  var _get = (0, $1af922eb41e03c8f$export$e6235c0d09b995d0).get(state),
    onRowAction = _get.actions.onRowAction;
  var _ref3 = (0, $cVkRF$useSelectableItem)({
      selectionManager: state.selectionManager,
      key: node.key,
      ref: ref,
      isVirtualized: isVirtualized,
      shouldSelectOnPressUp: shouldSelectOnPressUp,
      onAction: onRowAction ? function () {
        return onRowAction(node.key);
      } : onAction,
      isDisabled: state.collection.size === 0
    }),
    itemProps = _ref3.itemProps,
    states = _objectWithoutProperties(_ref3, ["itemProps"]);
  var isSelected = state.selectionManager.isSelected(node.key);
  var rowProps = _objectSpread({
    role: "row",
    "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined,
    "aria-disabled": states.isDisabled || undefined
  }, itemProps);
  if (isVirtualized) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
  return _objectSpread({
    rowProps: rowProps
  }, states);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c(props, state, ref) {
  var node = props.node,
    isVirtualized = props.isVirtualized,
    _props$focusMode = props.focusMode,
    focusMode = _props$focusMode === void 0 ? "child" : _props$focusMode,
    shouldSelectOnPressUp = props.shouldSelectOnPressUp,
    onAction = props.onAction;
  var _ref4 = (0, $cVkRF$useLocale)(),
    direction = _ref4.direction;
  var _get2 = (0, $1af922eb41e03c8f$export$e6235c0d09b995d0).get(state),
    keyboardDelegate = _get2.keyboardDelegate,
    onCellAction = _get2.actions.onCellAction; // We need to track the key of the item at the time it was last focused so that we force
  // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
  var keyWhenFocused = (0, $cVkRF$useRef)(null);
  // Handles focusing the cell. If there is a focusable child,
  // it is focused, otherwise the cell itself is focused.
  var focus = function focus() {
    var treeWalker = (0, $cVkRF$getFocusableTreeWalker)(ref.current);
    if (focusMode === "child") {
      // If focus is already on a focusable child within the cell, early return so we don't shift focus
      if (ref.current.contains(document.activeElement) && ref.current !== document.activeElement) return;
      var focusable = state.selectionManager.childFocusStrategy === "last" ? $ab90dcbc1b5466d0$var$last(treeWalker) : treeWalker.firstChild();
      if (focusable) {
        (0, $cVkRF$focusSafely)(focusable);
        return;
      }
    }
    if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, $cVkRF$focusSafely)(ref.current);
  };
  var _ref5 = (0, $cVkRF$useSelectableItem)({
      selectionManager: state.selectionManager,
      key: node.key,
      ref: ref,
      isVirtualized: isVirtualized,
      focus: focus,
      shouldSelectOnPressUp: shouldSelectOnPressUp,
      onAction: onCellAction ? function () {
        return onCellAction(node.key);
      } : onAction,
      isDisabled: state.collection.size === 0
    }),
    itemProps = _ref5.itemProps,
    isPressed = _ref5.isPressed;
  var onKeyDownCapture = function onKeyDownCapture(e) {
    if (!e.currentTarget.contains(e.target) || state.isKeyboardNavigationDisabled) return;
    var walker = (0, $cVkRF$getFocusableTreeWalker)(ref.current);
    walker.currentNode = document.activeElement;
    switch (e.key) {
      case "ArrowLeft":
        {
          // Find the next focusable element within the cell.
          var focusable = direction === "rtl" ? walker.nextNode() : walker.previousNode();
          // Don't focus the cell itself if focusMode is "child"
          if (focusMode === "child" && focusable === ref.current) focusable = null;
          if (focusable) {
            e.preventDefault();
            e.stopPropagation();
            (0, $cVkRF$focusSafely)(focusable);
            (0, $cVkRF$scrollIntoViewport)(focusable, {
              containingElement: (0, $cVkRF$getScrollParent)(ref.current)
            });
          } else {
            // If there is no next focusable child, then move to the next cell to the left of this one.
            // This will be handled by useSelectableCollection. However, if there is no cell to the left
            // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
            // same as this one. In that case we need to handle focusing either the cell or the first/last
            // child, depending on the focus mode.
            var prev = keyboardDelegate.getKeyLeftOf(node.key);
            if (prev !== node.key) break;
            e.preventDefault();
            e.stopPropagation();
            if (focusMode === "cell" && direction === "rtl") {
              (0, $cVkRF$focusSafely)(ref.current);
              (0, $cVkRF$scrollIntoViewport)(ref.current, {
                containingElement: (0, $cVkRF$getScrollParent)(ref.current)
              });
            } else {
              walker.currentNode = ref.current;
              focusable = direction === "rtl" ? walker.firstChild() : $ab90dcbc1b5466d0$var$last(walker);
              if (focusable) {
                (0, $cVkRF$focusSafely)(focusable);
                (0, $cVkRF$scrollIntoViewport)(focusable, {
                  containingElement: (0, $cVkRF$getScrollParent)(ref.current)
                });
              }
            }
          }
          break;
        }
      case "ArrowRight":
        {
          var _focusable = direction === "rtl" ? walker.previousNode() : walker.nextNode();
          if (focusMode === "child" && _focusable === ref.current) _focusable = null;
          if (_focusable) {
            e.preventDefault();
            e.stopPropagation();
            (0, $cVkRF$focusSafely)(_focusable);
            (0, $cVkRF$scrollIntoViewport)(_focusable, {
              containingElement: (0, $cVkRF$getScrollParent)(ref.current)
            });
          } else {
            var next = keyboardDelegate.getKeyRightOf(node.key);
            if (next !== node.key) break;
            e.preventDefault();
            e.stopPropagation();
            if (focusMode === "cell" && direction === "ltr") {
              (0, $cVkRF$focusSafely)(ref.current);
              (0, $cVkRF$scrollIntoViewport)(ref.current, {
                containingElement: (0, $cVkRF$getScrollParent)(ref.current)
              });
            } else {
              walker.currentNode = ref.current;
              _focusable = direction === "rtl" ? $ab90dcbc1b5466d0$var$last(walker) : walker.firstChild();
              if (_focusable) {
                (0, $cVkRF$focusSafely)(_focusable);
                (0, $cVkRF$scrollIntoViewport)(_focusable, {
                  containingElement: (0, $cVkRF$getScrollParent)(ref.current)
                });
              }
            }
          }
          break;
        }
      case "ArrowUp":
      case "ArrowDown":
        // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
        // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
        // bubbles and gets handled by useSelectableCollection.
        if (!e.altKey && ref.current.contains(e.target)) {
          e.stopPropagation();
          e.preventDefault();
          ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
        }
        break;
    }
  };
  // Grid cells can have focusable elements inside them. In this case, focus should
  // be marshalled to that element rather than focusing the cell itself.
  var onFocus = function onFocus(e) {
    keyWhenFocused.current = node.key;
    if (e.target !== ref.current) {
      // useSelectableItem only handles setting the focused key when
      // the focused element is the gridcell itself. We also want to
      // set the focused key when a child element receives focus.
      // If focus is currently visible (e.g. the user is navigating with the keyboard),
      // then skip this. We want to restore focus to the previously focused row/cell
      // in that case since the table should act like a single tab stop.
      if (!(0, $cVkRF$isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
      return;
    }
    // If the cell itself is focused, wait a frame so that focus finishes propagatating
    // up to the tree, and move focus to a focusable child if possible.
    requestAnimationFrame(function () {
      if (focusMode === "child" && document.activeElement === ref.current) focus();
    });
  };
  var gridCellProps = (0, $cVkRF$mergeProps)(itemProps, {
    role: "gridcell",
    onKeyDownCapture: onKeyDownCapture,
    onFocus: onFocus
  });
  var _node_colIndex;
  if (isVirtualized) gridCellProps["aria-colindex"] = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + 1; // aria-colindex is 1-based
  // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
  // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
  // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
  // To avoid this, remove the tabIndex from the cell briefly on pointer down.
  if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = function (e) {
    var el = e.currentTarget;
    var tabindex = el.getAttribute("tabindex");
    el.removeAttribute("tabindex");
    requestAnimationFrame(function () {
      el.setAttribute("tabindex", tabindex);
    });
  };
  return {
    gridCellProps: gridCellProps,
    isPressed: isPressed
  };
}
function $ab90dcbc1b5466d0$var$last(walker) {
  var next;
  var last;
  do {
    last = walker.lastChild();
    if (last) next = last;
  } while (last);
  return next;
}
function $7cb39d07f245a780$export$70e2eed1a92976ad(props, state) {
  var key = props.key;
  var manager = state.selectionManager;
  var checkboxId = (0, $cVkRF$useId)();
  var isDisabled = !state.selectionManager.canSelectItem(key);
  var isSelected = state.selectionManager.isSelected(key);
  var onChange = function onChange() {
    return manager.select(key);
  };
  var stringFormatter = (0, $cVkRF$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($835c96616a7cb4f9$exports)), "@react-aria/grid");
  return {
    checkboxProps: {
      id: checkboxId,
      "aria-label": stringFormatter.format("select"),
      isSelected: isSelected,
      isDisabled: isDisabled,
      onChange: onChange
    }
  };
}
export { $d1c300d9c497e402$export$de9feff04fda126e as GridKeyboardDelegate, $83c6e2eafa584c67$export$f6b86a04e5d66d90 as useGrid, $e45487f8ba1cbdbf$export$d3037f5d3f3e51bf as useGridRowGroup, $4159a7a9cbb0cc18$export$96357d5a73f686fa as useGridRow, $ab90dcbc1b5466d0$export$c7e10bfc0c59f67c as useGridCell, $7cb39d07f245a780$export$70e2eed1a92976ad as useGridSelectionCheckbox, $5b9b5b5723db6ae1$export$be42ebdab07ae4c2 as useHighlightSelectionDescription, $92599c3fd427b763$export$137e594ef3218a10 as useGridSelectionAnnouncement };